import _ from 'lodash';
import { getRandomInt } from '~/shared';

const wireColors = [
	{
		start: '#44FF00',
		end: '#4AB523',
	},
	{
		start: '#FF3CA7',
		end: '#B52373',
	},
	{
		start: '#FFCC00',
		end: '#B59823',
	},
	{
		start: '#015AFF',
		end: '#2356B5',
	},
	{
		start: '#FF0000',
		end: '#B52323',
	},
];

const wirePositions = [
	{
		top: 262,
		gap: 80,
	},
	{
		top: 192,
		gap: 80,
	},
	{
		top: 167,
		gap: 50,
	},
	{
		top: 172,
		gap: 20,
	},
];

export const generateGameField = () => {
	const wiresCount = getRandomInt(2, 5);

	const leftColors = _.sampleSize(wireColors, wiresCount);
	const rightColors = _.shuffle(leftColors);
	const positions = wirePositions[wiresCount - 2];

	return {
		leftColors,
		rightColors,
		wiresCount,
		positions,
	};
};
